import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Navigation from './screens/navigation/';
import Login from './screens/login/login';
import CssBaseline from '@mui/material/CssBaseline';
import CircularProgress from '@mui/material/CircularProgress';
import { styled, ThemeProvider } from '@mui/material/styles';
import Message from './components/message';
import theme from './theme';

import ListGroup from './screens/group/list';
import EditGroup from './screens/group/edit';
import ListAccount from './screens/account/list';
import EditAccount from './screens/account/edit';
import ListCategory from './screens/category/list';
import EditCategory from './screens/category/edit';
import ListTransaction from './screens/transaction/list';
import EditTransaction from './screens/transaction/edit';
import TransferTransaction from './screens/transaction/transfer';
import BalancePerAccount from './screens/balancePerAccount/report';
import BalancePerCategory from './screens/balancePerCategory/report';
import FutureBalance from './screens/futureBalance/report';
import EmailVerificationPage from './components/auth/EmailVerificationPage';
import ResetPasswordForm from './components/auth/ResetPasswordForm';
import MyDashboard from './screens/dashboard/myDashboard';

const StyledDiv = styled('div')(({ theme }) => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    height: '100vh',
    overflow: 'auto',
  },
  appBarSpacer: theme.mixins.toolbar,
}));

const App = () => {
  const location = useLocation();
  
  // Redux state selectors
  const user = useSelector(state => state.account.user);
  const appMain = useSelector(state => state.appMain);

  let routes =
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/account/verify-email" element={<EmailVerificationPage /> } />
      <Route path="/account/reset-password" element={<ResetPasswordForm /> } />
    </Routes>

  if (!!user) {
    routes =
      <Routes>
        <Route path="/groups/new" element={<EditGroup />} />
        <Route path="/groups/edit/:id" element={<EditGroup />} />
        <Route path="/groups" element={<ListGroup />} />
        <Route path="/accounts/new" element={<EditAccount />} />
        <Route path="/accounts/edit/:id" element={<EditAccount />} />
        <Route path="/accounts" element={<ListAccount />} />
        <Route path="/categories/new" element={<EditCategory />} />
        <Route path="/categories/edit/:id" element={<EditCategory />} />
        <Route path="/categories" element={<ListCategory />} />
        <Route path="/transactions/new" element={<EditTransaction />} />
        <Route path="/transactions/edit/:id" element={<EditTransaction />} />
        <Route path="/transactions/transfer" element={<TransferTransaction />} />
        <Route path="/transactions" element={<ListTransaction />} />
        <Route path="/balance-per-account" element={<BalancePerAccount />} />
        <Route path="/balance-per-category" element={<BalancePerCategory />} />
        <Route path="/future-balance" element={<FutureBalance />} />
        <Route path="/mydashboard" element={<MyDashboard />} />
        <Route path="*" element={<EditTransaction />} />
      </Routes>
  } else if (location.pathname !== '/login' 
      && location.pathname !== '/account/verify-email'
      && location.pathname !== '/account/reset-password') {
    routes = <Navigate to='/login' replace />
  }

  let loadingComponent = null;
  if (appMain.loading) {
    loadingComponent = <div className="loading">
      <CircularProgress></CircularProgress>
    </div>
  }

  return (
    <ThemeProvider theme={theme}>
      <StyledDiv sx={{ 
        display: 'flex',
        position: 'relative',
      }}>
        {loadingComponent}
        <Message />
        <CssBaseline />
        <Navigation />
        <main style={{
          flexGrow: 1,
          padding: '15px',
          height: '100vh',
          overflow: 'auto',
          backgroundColor: '#f8f9fa',
          width: '100%',
        }}>
          <div style={{ minHeight: '70px' }} />
          <div className="container" style={{
            margin: '0px', 
            paddingBottom: '60px',
            maxWidth: '100%',
          }}>
            {routes}
          </div>
        </main>
      </StyledDiv>
    </ThemeProvider>
  );
};

export default App;

